import React, { useEffect, useState } from "react";
import axios from "axios";

import {
    Paper,
    Typography,
    CircularProgress,
    Box,
    Alert
} from "@mui/material";

import {
    Folder as FolderIcon
} from "@mui/icons-material";

import {
    SimpleTreeView,
    TreeItem
} from "@mui/x-tree-view";

const API_URL =
    process.env.REACT_APP_API_URL ||
    "http://localhost:5000";

export default function FolderTree({

    selectedFolder,

    onFolderSelect

}) {

    const [tree, setTree] = useState([]);

    const [loading, setLoading] = useState(true);

    const [error, setError] = useState("");

    const [expandedItems, setExpandedItems] =
        useState([]);

    useEffect(() => {

        loadTree();

    }, []);

    async function loadTree() {

        try {

            setLoading(true);

            setError("");

            const response =
                await axios.get(

                    `${API_URL}/knowledge/tree`

                );

            setTree(response.data || []);
            console.log(response.data);

        }

        catch (err) {

            console.error(err);

            setError(

                "Unable to load folder tree."

            );

        }

        finally {

            setLoading(false);

        }

    }
        function renderNode(node) {
console.log(node);
        return (

            <TreeItem

                key={node.folderPath}

                itemId={node.folderPath}

                label={

                    <Box

                        sx={{

                            display: "flex",

                            alignItems: "center",

                            gap: 1

                        }}

                    >

                        <FolderIcon

                            color="primary"

                            fontSize="small"

                        />

                        <Typography

                            variant="body2"

                        >

                            {node.title}

                        </Typography>

                    </Box>

                }

            >

                {

                    node.children &&

                    node.children.length > 0 &&

                    node.children.map(child =>

                        renderNode(child)

                    )

                }

            </TreeItem>

        );

    }
        /*
    ============================================
    LOADING
    ============================================
    */

    if (loading) {

        return (

            <Paper

                elevation={2}

                sx={{

                    p: 2,

                    height: "100%",

                    display: "flex",

                    justifyContent: "center",

                    alignItems: "center"

                }}

            >

                <CircularProgress />

            </Paper>

        );

    }

    /*
    ============================================
    ERROR
    ============================================
    */

    if (error) {

        return (

            <Paper

                elevation={2}

                sx={{

                    p: 2,

                    height: "100%"

                }}

            >

                <Alert severity="error">

                    {error}

                </Alert>

            </Paper>

        );

    }
        /*
    ============================================
    MAIN UI
    ============================================
    */

    return (

        <Paper

            elevation={2}

            sx={{

                p: 2,

                height: "100%",

                overflow: "auto"

            }}

        >

            <Typography

                variant="h6"

                fontWeight="bold"

                gutterBottom

            >

                Folder Explorer

            </Typography>

            {

                tree.length === 0 ?

                (

                    <Alert severity="info">

                        No folders found.

                    </Alert>

                )

                :

                (

                    <SimpleTreeView
    expandedItems={expandedItems}
    onExpandedItemsChange={(event, items) => {
        setExpandedItems(items);
    }}
    selectedItems={
        selectedFolder || null
    }
    onSelectedItemsChange={(event, itemId) => {
        if (!itemId) return;

        onFolderSelect?.(itemId);
    }}
>
    {tree.map(renderNode)}
</SimpleTreeView>

                )

            }

        </Paper>

    );
    }